module.exports = __webpack_public_path__ + "fonts/montserrat-v12-latin-700italic.ca627c5c.woff";